import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiService {
  private api: string;
  private httpOptions: { headers: HttpHeaders; responseType: 'text' };

  constructor(private http: HttpClient) {
    this.api = `${environment.api_url}`;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain'
      }),
      responseType: 'text'
    };
  }

  public sendPrompt(prompt: string): Observable<string> {
    return this.http.post(
      `${this.api}/chat`,
      prompt,
      this.httpOptions
    ) as Observable<string>;
  }
}
